export default __webpack_public_path__ + "static/blockchain@2x-d1ab6c7660f308b6c64984638e5d95e8.png";